<template>
	<el-dialog :close-on-click-modal="false" title="找回报名序号" @open="open" :visible.sync="dialogVisible" width="600px"
		:before-close="handleClose">
		<h3>{{ examination_name }}</h3>
		<el-form v-show="!id" :inline="true" :model="form" ref="formRef" :rules="rules" hide-required-asterisk>
			<el-form-item label="真实姓名" prop="name">
				<el-input style="width: 475px;" v-model="form.name" placeholder="请输入真实姓名"></el-input>
			</el-form-item>
			<el-form-item label="身份证号" prop="card_id">
				<el-input style="width: 475px;" v-model="form.card_id" maxlength="18" placeholder="请输入身份证号"></el-input>
			</el-form-item>
			<el-form-item label="报考单位" prop="department_id">
				<el-select v-model="form.department_id" placeholder="请选择">
					<el-option v-for="item in department_options" :key="item.department_id"
						:label="item.department_name" :value="item.department_id"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="报考职位" prop="position_id">
				<el-select v-model="form.position_id" placeholder="请选择">
					<el-option v-for="item in position_options" :key="item.position_id" :label="item.position_name"
						:value="item.position_id"></el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<p v-show="id" class="id">
			您的报名序号是：
			<br />
			<span style="color: red;">{{ id }}</span>
		</p>
		<span slot="footer">
			<el-button v-if="!id" type="primary" @click="onSubmit()">查询</el-button>
			<el-button v-else type="primary" @click="handleClose()">关闭</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import {
		reqShowRetrieveLoginId,
		reqRetrieveLoginId
	} from '@/api';
	export default {
		data() {
			return {
				dialogVisible: false,
				form: {},
				rules: {
					name: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
					card_id: [{
						required: true,
						message: '请输入身份证号',
						trigger: 'blur'
					}],
					department_id: [{
						required: true,
						message: '请选择报考单位',
						trigger: 'change'
					}],
					position_id: [{
						required: true,
						message: '请选择报考职位',
						trigger: 'change'
					}]
				},
				department_options: [],
				position_options: [],
				id: ''
			};
		},
		computed: {
			...mapState({
				company_id: state => state.system.company_id,
				examination_id: state => state.system.examInfo.examination_id,
				examination_name: state => state.system.examInfo.examination_name
			})
		},
		watch: {
			'form.department_id': {
				handler(val) {
					this.form = {
						...this.form,
						position_id: ''
					};
					this.getPosition();
				}
			}
		},
		methods: {
			open() {
				this.getDepartment();
			},
			// 获取部门
			getDepartment() {
				reqShowRetrieveLoginId({
					company_id: this.company_id
				}).then(res => {
					this.department_options = res.data;
				});
			},
			// 获取岗位
			getPosition() {
				reqShowRetrieveLoginId({
					company_id: this.company_id,
					department_id: this.form.department_id
				}).then(res => {
					this.position_options = res.data;
				});
			},
			handleClose() {
				this.dialogVisible = false;
				setTimeout(() => {
					this.form = {};
					this.$refs.formRef.resetFields();
				});
			},
			onSubmit() {
				this.$refs['formRef'].validate(valid => {
					if (valid) {
						reqRetrieveLoginId({
							examination_id: this.examination_id,
							...this.form
						}).then(res => {
							this.$nextTick(() => {
								this.id = res.data;
							})
						});
					} else {
						return false;
					}
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	h3 {
		text-align: center;
		margin-bottom: 20px;
	}

	.id {
		font-size: 16px;

		span {
			font-size: 14px;
			line-height: 1.7;
		}
	}
</style>
